import {
  OpenModalIcon,
  CategoriesContainer,
  CategoriesWrapper,
} from "../StylesCatalogs";

import {
  UsersIcon,
  ClientIcon,
  AdapterIcon,
  ExpertIcon,
  BranchesIcon,
  CoinIcon,
} from "../../../assets/icons/Icons";
export default function CategoriesComponent({ handleTabChange, dataView, activeIconUser,activeIconClient, activeIconExpert, activeIconAdapter, activeIconBranch, activeIconCoin, }) {
  const {
    setShowModalAddUser,
    setShowModalCreateClient,
    setShowModalCreateExpert,
    setShowModalCreateAdapter,
    setShowModalCreateBranch,
    setShowModalCreateCoin,
  } = dataView;

  
  function viewModalAddUser() {
    setShowModalAddUser(true);
  }

  function viewModalCreateClient() {
    setShowModalCreateClient(true);
  }

  function viewModalCreateExpert() {
    setShowModalCreateExpert(true);
  }

  function viewModalCreateAdapter() {
    setShowModalCreateAdapter(true);
  }

  function viewModalCreateBranch() {
    setShowModalCreateBranch(true);
  }

  function viewModalCreateCoin() {
    setShowModalCreateCoin(true);
  }

  return (
    <CategoriesWrapper>
      <CategoriesContainer>
        <UsersIcon negative={activeIconUser}/>
        <p onClick={() => handleTabChange("Users")}>Usuarios</p>
        <OpenModalIcon onClick={viewModalAddUser}>+</OpenModalIcon>
      </CategoriesContainer>
      <CategoriesContainer>
        <ClientIcon negative={activeIconClient}/>
        <p onClick={() => handleTabChange("Clients")}>Clientes</p>
        <OpenModalIcon onClick={viewModalCreateClient}>+</OpenModalIcon>
      </CategoriesContainer>
      <CategoriesContainer>
        <ExpertIcon negative={activeIconExpert}/>
        <p onClick={() => handleTabChange("Experts")}>Expertos</p>
        <OpenModalIcon onClick={viewModalCreateExpert}>+</OpenModalIcon>
      </CategoriesContainer>
      <CategoriesContainer>
        <AdapterIcon negative={activeIconAdapter}/>
        <p onClick={() => handleTabChange("Fixers")}>Ajustadores</p>
        <OpenModalIcon onClick={viewModalCreateAdapter}>+</OpenModalIcon>
      </CategoriesContainer>
      <CategoriesContainer>
        <BranchesIcon negative={activeIconBranch}/>
        <p onClick={() => handleTabChange("Branches")}>Ramos</p>
        <OpenModalIcon onClick={viewModalCreateBranch}>+</OpenModalIcon>
      </CategoriesContainer>
      <CategoriesContainer>
        <CoinIcon negative={activeIconCoin}/>
        <p onClick={() => handleTabChange("Coin")}>Moneda</p>
        <OpenModalIcon onClick={viewModalCreateCoin}>+</OpenModalIcon>
      </CategoriesContainer>
    </CategoriesWrapper>
  );
}
